import React from 'react';
import styled from 'styled-components/macro';
import {
  SatisfactionBar,
  Typography,
  SatisfactionOpenType,
} from '@deeptrue-frontend/ui';
import { useFormatMessage } from 'components/IntlProvider';

const MainTitle = styled(Typography)`
  margin-bottom: 2rem;
`;

const ReportBlock = styled.div`
  padding: 1.5rem 4rem 2rem;
  border-bottom: 1px solid #e6e6e5;
`;

const SatisfactionNoteWrapper = styled.div`
  max-width: 37rem;
`;

const Ol = styled.ol`
  font-family: Inter, Helvetica;
  padding: 0 1rem;
  margin: 0;
`;

const Li = styled.li`
  font-family: Inter, Helvetica;
`;

interface Props {
  reportData: any;
  isSingleReport?: boolean;
}

const Report = ({ reportData, isSingleReport }: Props) => {
  const t = useFormatMessage();
  return reportData.map((set: any, key: any) => {
    const { name, groups, values, isOpenQuestionType } = set;

    return (
      <ReportBlock key={key}>
        <MainTitle variant="h6">
          {key + 1}
          {'. '}
          {name}
        </MainTitle>
        {groups && (
          <Ol type="a">
            {groups.map((group: any, key: any) => (
              <Li key={key}>
                {group.name}
                <SatisfactionBar
                  satisfaction={[
                    {
                      values: group.values.map((value: any) => ({
                        text: value.name,
                        value: value.value.toFixed(1),
                      })),
                    },
                  ]}
                />
              </Li>
            ))}
          </Ol>
        )}
        {values && isOpenQuestionType && (
          <SatisfactionNoteWrapper>
            {values.map((value: any, index: number) => {
              return (
                <SatisfactionOpenType
                  key={index}
                  index={index}
                  title={value.name}
                  showNrOfResponses={isSingleReport ? false : true}
                  openAnswers={value.value}
                  type="a"
                  i18n={{
                    response: t(
                      'customerSatisfaction.openType.response',
                      'response'
                    ),
                    responses: t(
                      'customerSatisfaction.openType.responses',
                      'responses'
                    ),
                    viewAll: t(
                      'customerSatisfaction.openType.viewAll',
                      'View all'
                    ),
                  }}
                />
              );
            })}
          </SatisfactionNoteWrapper>
        )}
        {values && !isOpenQuestionType && (
          <SatisfactionNoteWrapper>
            <SatisfactionBar
              type="a"
              satisfaction={[
                {
                  values: values.map((value: any) => ({
                    text: value.name,
                    value: value.value.toFixed(1),
                  })),
                },
              ]}
            />
          </SatisfactionNoteWrapper>
        )}
      </ReportBlock>
    );
  });
};

export default Report;
